/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */
//"use strict";
/* global checkCustom  */
		// functions to save config files ( either view or carousel) and options
expocadfx.storeXml = ( function(){
	var data = expocadfx.fxData;
	var txt = expocadfx.txt;
	var isTrue = expocadfx.util.isTrue;
    var fixColor = expocadfx.util.fixColor;
    var makeGradientStyle = expocadfx.util.makeGradientStyle;
	var util = expocadfx.util;
	var elemById = expocadfx.element.elementById;
    
    
    function getStyles( xml, clr1, clr2) {
        var color2 = "";
        var result = [];
        var tmp = xml.getElementsByTagName( clr1)[0];
        if( tmp && tmp.textContent !== "") {
            result.push( fixColor( tmp.textContent));
            
            tmp = xml.getElementsByTagName( clr2)[0];
            if( tmp && tmp.textContent !== "") {
                color2 = fixColor( tmp.textContent);
                if( color2 !== result[0]) {
                    result.push( makeGradientStyle( result[0], color2));
                }
            }
        }
        return result;
    }
    
	function saveConfig( config, xml) {
		var xmlList = xml.getElementsByTagName("n");
        var xmlClasses = xml.getElementsByTagName("C");
        var numClasses = xmlClasses.length;
        var i = 0;
        for( i = 0; i < numClasses; i++) {      // convert HTMLcollection to array, keep IE happy
            config.arBoothClasses.push( { name: xmlClasses[i].getAttribute( "n"),
                color: xmlClasses[i].getAttribute( "c").replace( "0x", "#") } );
        }
        
        config.clrBackground = xmlList[0].getAttribute("bg");
        if( config.clrBackground) {
            config.clrBackground = config.clrBackground.replace( "0x", "#");
        }
        
        config.buildingColor = xmlList[0].getAttribute("bd").replace( "0x", "#");
        
        
        //  if colors in config
        config.clrRent = xmlList[0].getAttribute("r");
        if( config.clrRent) {
            config.clrRent = config.clrRent.replace( "0x", "#");
        }
        config.clrHold = xmlList[0].getAttribute("h");
        if( config.clrHold) {
            config.clrHold = config.clrHold.replace( "0x", "#");
        }
        config.clrAvailable = xmlList[0].getAttribute("a");
        if( config.clrAvailable) {
            config.clrAvailable = config.clrAvailable.replace( "0x", "#");
        }
        config.clrSelected = xmlList[0].getAttribute("sl");
        if( config.clrSelected) {
            config.clrSelected = config.clrSelected.replace( "0x", "#");
        }
        config.clrHighlight = xmlList[0].getAttribute("hl");
        if( config.clrHighlight) {
            config.clrHighlight = config.clrHighlight.replace( "0x", "#");
        }
        
        config.clrBoothText = xmlList[0].getAttribute("t").replace( "0x", "#");
        config.clrBuildingText = xmlList[0].getAttribute("bt").replace( "0x", "#");

        config.fileNumber = parseInt(xmlList[0].getAttribute("al"), 10);
        config.contactEmail = xmlList[0].getAttribute("cL");
        config.availableUrl = xmlList[0].getAttribute("aL");
        config.availableText1 = xmlList[0].getAttribute("aT1");
        config.availableText2 = xmlList[0].getAttribute("aT2");
        config.emailSubject1 = xmlList[0].getAttribute("cM1");
        config.emailSubject2 = xmlList[0].getAttribute("cM2");

        config.checkSum = parseInt(xmlList[0].getAttribute("s"), 10);
        config.year = parseInt(xmlList[0].getAttribute("y"), 10);
        config.month = parseInt(xmlList[0].getAttribute("m"), 10);
        config.day = parseInt(xmlList[0].getAttribute("d"), 10);
        config.eventTitle = xmlList[0].getAttribute("eT");
        config.eventName = xmlList[0].getAttribute("eN");
        config.viewName = xmlList[0].getAttribute("vN");
        config.viewTitle = xmlList[0].getAttribute("vT");
        config.showUnits = xmlList[0].getAttribute("u");
        if( config.units === "") {     // don't over write user or query string value
            config.units = config.showUnits;
        }
        config.updateCheckInterval = xmlList[0].getAttribute("cT");
			
			// convert text T/F to boolean
        config.bSocialButtons = ( xmlList[0].getAttribute("SMB") === "T");
        config.hasMultipleViews = ( xmlList[0].getAttribute("car") === "T");
        config.bPDF = ( xmlList[0].getAttribute("PDF") === "T");
        config.bUrl = ( xmlList[0].getAttribute("url") === "T");
        config.bPreviewLink = ( xmlList[0].getAttribute("pop") === "T");
        config.bOverlay = true;   ///////  moving to options !!! ( xmlList[0].getAttribute("OVR") === "T");  
        config.bDataEncrypted = ( xmlList[0].getAttribute("eD") === "T");
        //config.bUseApi = ( xmlList[0].getAttribute("API") === "T");  // ALWAYS CALL IF IT'S THERE!
        if( window.checkCustom) {
            config.bUseApi = String( checkCustom()) === "1";
        }
        else {
            config.bUseApi = false;
        }
        
        config.bServerTime = ( xmlList[0].getAttribute("sT") === "T");
        config.bLegend = ( xmlList[0].getAttribute("LEG") === "T");
        config.bCategoryData = (xmlList[0].getAttribute("ddC") === "T");
        config.bPavilionData = (xmlList[0].getAttribute("ddP") === "T");
        config.bSubShowData = (xmlList[0].getAttribute("ddS") === "T");
        config.bCountryData = (xmlList[0].getAttribute("ddY") === "T");
		
        config.savedDate = xmlList[0].getAttribute("dT");
        config.savedTime = xmlList[0].getAttribute("tT");
        config.scaleFactor = parseFloat(xmlList[0].getAttribute("zf"));
        config.version = xmlList[0].getAttribute("Ver");
        config.expocadVersion = xmlList[0].getAttribute("ExV");
        config.rentMode = (xmlList[0].getAttribute("rm") === "T");
        config.holdMode = (xmlList[0].getAttribute("hm") === "T");
		
        txt.RENT_MODE_LABEL = xmlList[0].getAttribute( "rmt");
        txt.HOLD_MODE_LABEL = xmlList[0].getAttribute( "hmt");
        
        expocadfx.styles.mainHeader.clrBg = xmlList[0].getAttribute("hC").replace( "0x", "#");
        expocadfx.styles.footer.clrBg = expocadfx.styles.mainHeader.clrBg;
			
        config.urlFacilityView = xmlList[0].getAttribute("rURL");
			
        config.hdrLogoSource = xmlList[0].getAttribute("hL");
        config.password = xmlList[0].getAttribute("eP");
        config.activationCode = xmlList[0].getAttribute("cv");
        
        if(config.version >= 4.4){
            config.printLayoutScale = xmlList[0].getAttribute("pS");
            config.printLayoutAdjustmentX = xmlList[0].getAttribute("pX");
            config.printLayoutAdjustmentY = xmlList[0].getAttribute("pY");
            config.printLayoutOrientation = xmlList[0].getAttribute("pO");
        }

        // User defined GPS->Coords From Desktop
        config.refLat0 = xmlList[0].getAttribute("Lat1");
        config.refLon0 = xmlList[0].getAttribute("Lon1");
        config.refLat1 = xmlList[0].getAttribute("Lat2");
        config.refLon1 = xmlList[0].getAttribute("Lon2");
        
        config.refFXX0 = xmlList[0].getAttribute("GPS1x");
        config.refFXY0 = xmlList[0].getAttribute("GPS1y");
        config.refFXX1 = xmlList[0].getAttribute("GPS2x");
        config.refFXY1 = xmlList[0].getAttribute("GPS2y");

        // Add check that all attributes have values
        if(config.refLat0 && config.refLon0 && config.refLat1 && config.refLon1 && 
            config.refFXX0 && config.refFXY0 && config.refFXX1 && config.refFXY1){
            config.locationAvailable = true;
        }
			
			// 20130101  09 49 23 0017  --> 01/01/2013 at 09:49
        config.lastSaved = config.savedDate.substr( 4, 2) + "/" +
        config.savedDate.substr( 6, 2) + "/" +
        config.savedDate.substr( 0, 4) + "  at " +
        config.savedTime.substr( 0, 2) + ":" +
        config.savedTime.substr( 2, 2);
        
        xmlList = null;
        xml = null;
    }
    
    function multiConfig( config, xml) {
        var xmlList = xml.getElementsByTagName("c");
        
        config.eventTitle = xmlList[0].getAttribute("eT");
        config.eventName = xmlList[0].getAttribute("eN");

        expocadfx.styles.mainHeader.clrBg = xmlList[0].getAttribute("hC").replace( "0x", "#");
        expocadfx.styles.footer.clrBg = expocadfx.styles.mainHeader.clrBg;
		
        
        config.hdrLogoSource = xmlList[0].getAttribute("hL");
        config.bPDF = ( xmlList[0].getAttribute("PDF") === "T");
        config.bOverlay = ( xmlList[0].getAttribute("OVR") === "T");  
        config.bDataEncrypted = ( xmlList[0].getAttribute("eD") === "T");
        config.hasMultipleViews = true;
        config.hasFloorPlan = false;
        config.clrHighlight = "#ff0000";
        
        xmlList = null;
        xml = null;
    }
    
    function options( xml, config, style) {
        var tmp = null;
        var ar = null;
        var color2 = "";
        var rotation = "";
        var sign = 1;
		var xmlNodes = null;
		var i = 0;
        
        tmp = xml.getElementsByTagName( "AuthorizationKey")[0];
        if( tmp && tmp.textContent !== "") {
            config.authorizationKey = tmp.textContent;
        }
        tmp = xml.getElementsByTagName( "HeaderLogoFile")[0];
        if( tmp && tmp.textContent !== "") {
            config.hdrLogoSource = tmp.textContent;
        }
        tmp = xml.getElementsByTagName( "HeaderBgColor")[0];
        if( tmp && tmp.textContent !== "") {
            ar = tmp.textContent.split(",");
            style.mainHeader.clrBg = fixColor( ar[0]);
            if( ar.length === 2) {
                color2 = fixColor( ar[1]);
                if( color2 !== style.mainHeader.clrBg) {
                    tmp = xml.getElementsByTagName( "HeaderBgGradientRotation")[0];
                    if( tmp && tmp.textContent !== "") {
                        rotation = String( parseInt( tmp.textContent, 10) + 90);
                    }
                    style.mainHeader.gradBg = makeGradientStyle( style.mainHeader.clrBg,
                                                                  fixColor( ar[1]), rotation);
                }
            }
        }
        tmp = xml.getElementsByTagName( "HeaderTextColor")[0];
        if( tmp && tmp.textContent !== "") {
            style.mainHeader.clrText = fixColor( tmp.textContent);
        }
        tmp = xml.getElementsByTagName( "HeaderLogoUrl")[0];
        if( tmp && tmp.textContent !== "") {
            config.urlFacilityView = tmp.textContent;
        }
        
        tmp = xml.getElementsByTagName( "FooterBgColor")[0];
        if( tmp && tmp.textContent !== "") {
            ar = tmp.textContent.split(",");
            style.footer.clrBg = fixColor( ar[0]);
            if( ar.length === 2) {
                color2 = fixColor( ar[1]);
                if( color2 !== style.footer.clrBg) {
                    tmp = xml.getElementsByTagName( "FooterBgGradientRotation")[0];
                    if( tmp && tmp.textContent !== "") {
                        rotation = String( parseInt( tmp.textContent, 10) + 90);
                    }
                    else {
                        rotation = "";
                    }
                    style.footer.gradBg = makeGradientStyle( style.footer.clrBg,
                                                                  color2, rotation);
                }
            }
        }
        else {
            style.footer.clrBg = style.mainHeader.clrBg;
            style.footer.gradBg = style.mainHeader.gradBg;
        }
        tmp = xml.getElementsByTagName( "FooterTextColor")[0];
        if( tmp && tmp.textContent !== "") {
            style.footer.clrText = fixColor( tmp.textContent);
        }
        else {
            style.footer.clrText = style.mainHeader.clrText;
        }

        tmp = xml.getElementsByTagName( "WindowHeaderColor")[0];
        if( tmp && tmp.textContent !== "") {
            ar = tmp.textContent.split(",");
            style.windowHeader.clrBg = fixColor( ar[0]);
            if( ar.length === 2) {
                color2 = fixColor( ar[1]);
                if( color2 !== style.footer.clrBg) {
                    tmp = xml.getElementsByTagName( "WindowBgGradientRotation")[0];
                    if( tmp && tmp.textContent !== "") {
                        rotation = String( parseInt( tmp.textContent, 10) + 90);
                    }
                    else {
                        rotation = "";
                    }
                    style.windowHeader.gradBg = makeGradientStyle( style.footer.clrBg,
                                                                  color2, rotation);
                }
            }
        }
        else {
            style.windowHeader.clrBg = style.mainHeader.clrBg;
            style.windowHeader.gradBg = style.mainHeader.gradBg;
        }
        tmp = xml.getElementsByTagName( "WindowHeaderTextColor")[0];
        if( tmp && tmp.textContent !== "") {
            style.windowHeader.clrText = fixColor( tmp.textContent);
        }
        else {
            style.windowHeader.clrText = style.mainHeader.clrText;
        }
        
        tmp = xml.getElementsByTagName( "SocialMediaButtons")[0];
        if( tmp && tmp.textContent !== "") {
            config.bSocialButtons = isTrue( tmp.textContent);
        }
        tmp = xml.getElementsByTagName( "ShowEventTitle")[0];
        if( tmp && tmp.textContent !== "") {
            config.eventTitleLocation = tmp.textContent;
        }
        tmp = xml.getElementsByTagName( "EventTitle")[0];
        if( tmp && tmp.textContent !== "") {
            config.eventTitle = tmp.textContent;
            if( !config.hasMultipleViews) {        //  ?? should not be using view title if not multi-view
                config.viewTitle = tmp.textContent;
            }
        }
        tmp = xml.getElementsByTagName( "EventTitleTextColor")[0];
        if( tmp && tmp.textContent !== "") {
            config.clrEventTitleText = fixColor( tmp.textContent);
        }
        tmp = xml.getElementsByTagName( "EventTitleTextSize")[0];
        if( tmp && tmp.textContent !== "") {
            config.eventTitleTextSize = tmp.textContent;
        } 
        tmp = xml.getElementsByTagName( "ShowViewTitle")[0];
        if( tmp && tmp.textContent !== "") {
            config.viewTitleLocation = tmp.textContent;
        }
        tmp = xml.getElementsByTagName( "ViewTitle")[0];
        if( tmp && tmp.textContent !== "") {
            config.viewTitle = tmp.textContent;
        }
        tmp = xml.getElementsByTagName( "ViewTitleTextColor")[0];
        if( tmp && tmp.textContent !== "") {
            config.clrViewTitleText = fixColor( tmp.textContent);
        }   
        tmp = xml.getElementsByTagName( "ViewTitleTextSize")[0];
        if( tmp && tmp.textContent !== "") {
            config.viewTitleTextSize = tmp.textContent;
        }
//---------  Booth Colors    -------------------------------------------------------//  
        tmp = xml.getElementsByTagName( "RentedBoothColor")[0];
        if( tmp && tmp.textContent !== "") {
            config.clrRent = fixColor( tmp.textContent);
        }
        tmp = xml.getElementsByTagName( "HoldBoothColor")[0];
        if( tmp && tmp.textContent !== "") {
            config.clrHold = fixColor( tmp.textContent);
        }
        tmp = xml.getElementsByTagName( "AvailableBoothColor")[0];
        if( tmp && tmp.textContent !== "") {
            config.clrAvailable = fixColor( tmp.textContent);
        }
        tmp = xml.getElementsByTagName( "SelectedBoothColor")[0];
        if( tmp && tmp.textContent !== "") {
            config.clrSelected = fixColor( tmp.textContent);
        }
        tmp = xml.getElementsByTagName( "HighlightBoothColor")[0];
        if( tmp && tmp.textContent !== "") {
            config.clrHighlight = fixColor( tmp.textContent);
        }
        tmp = xml.getElementsByTagName( "BoothOutlineColor")[0];
        if( tmp && tmp.textContent !== "") {
            config.clrBoothBorder = fixColor( tmp.textContent);
        }
        tmp = xml.getElementsByTagName( "BoothAlpha")[0];
        if( tmp && tmp.textContent !== "") {
            config.BOOTH_ALPHA = parseFloat( tmp.textContent);
        }
        tmp = xml.getElementsByTagName( "EventTextColor")[0];
        if( tmp && tmp.textContent !== "") {
            config.clrBoothText = fixColor( tmp.textContent);
        }
		tmp = xml.getElementsByTagName( "BoothDimensionColor")[0];
        if( tmp && tmp.textContent !== "") {
            config.clrBoothDimensions = fixColor( tmp.textContent);
        }														  
        
//------------------------------------------------------------------------------------// 
        
        tmp = xml.getElementsByTagName( "PreviewEmailLink")[0];
        if( tmp && tmp.textContent !== "") {
            config.bPreviewLink = isTrue( tmp.textContent);
        }
        tmp = xml.getElementsByTagName( "Pass")[0];
        if( tmp && tmp.textContent !== "") {
            config.password = tmp.textContent;
        }
 //--------- Accordion Options  -------------------------------------------------------// 
        tmp = xml.getElementsByTagName( "HideAccordionCountryTab")[0];
        if( tmp && tmp.textContent !== "") {
            config.bHideCountryList = isTrue( tmp.textContent);
        }
        tmp = xml.getElementsByTagName( "HideAccordionAvailableTab")[0];
        if( tmp && tmp.textContent !== "") {
            config.bHideAvailableList = isTrue( tmp.textContent);
        }
        tmp = xml.getElementsByTagName( "AccExhibitorTextClr")[0];
        if( tmp && tmp.textContent !== "") {
            style.exhibitor.clrText = fixColor( tmp.textContent);
        }
        ar = getStyles( xml, "AccExhibitorBgClr1", "AccExhibitorBgClr2");
        style.exhibitor.clrBg =  ( ar.length > 0) ? ar[0] : "";
        style.exhibitor.gradBg = ( ar.length === 2) ? ar[1] : "";
        
        if( !config.bHideAvailableList) {
            tmp = xml.getElementsByTagName( "AccAvailableTextClr")[0];
            if( tmp && tmp.textContent !== "") {
                style.availableBooth.clrText = fixColor( tmp.textContent);
            }
            ar = getStyles( xml, "AccAvailableBgClr1", "AccAvailableBgClr2");
            style.availableBooth.clrBg = ( ar.length > 0) ? ar[0] : "";
            style.availableBooth.gradBg = ( ar.length === 2) ? ar[1] : "";
        }
        tmp = xml.getElementsByTagName( "AccCategoryTextClr")[0];
        if( tmp && tmp.textContent !== "") {
            style.category.clrText = fixColor( tmp.textContent);
        }
        ar = getStyles( xml, "AccCategoryBgClr1", "AccCategoryBgClr2");
        style.category.clrBg = ( ar.length > 0) ? ar[0] : "";
        style.category.gradBg = ( ar.length === 2) ? ar[1] : "";
        
        tmp = xml.getElementsByTagName( "AccPavilionTextClr")[0];
        if( tmp && tmp.textContent !== "") {
            style.pavilion.clrText = fixColor( tmp.textContent);
        }
        ar = getStyles( xml, "AccPavilionBgClr1", "AccPavilionBgClr2");
        style.pavilion.clrBg = ( ar.length > 0) ? ar[0] : "";
        style.pavilion.gradBg = ( ar.length === 2) ? ar[1] : "";
        
        tmp = xml.getElementsByTagName( "AccShowInShowTextClr")[0];
        if( tmp && tmp.textContent !== "") {
            style.subShow.clrText = fixColor( tmp.textContent);
        }
        ar = getStyles( xml, "AccShowInShowBgClr1", "AccShowInShowBgClr2");
        style.subShow.clrBg = ( ar.length > 0) ? ar[0] : "";
        style.subShow.gradBg = ( ar.length === 2) ? ar[1] : "";
        
        if( !config.bHideCountryList) {
            tmp = xml.getElementsByTagName( "AccCountryTextClr")[0];
            if( tmp && tmp.textContent !== "") {
                style.country.clrText = fixColor( tmp.textContent);
            }
            ar = getStyles( xml, "AccCountryBgClr1", "AccCountryBgClr2");
            style.country.clrBg = ( ar.length > 0) ? ar[0] : "";
            style.country.gradBg = ( ar.length === 2) ? ar[1] : "";
        }
        tmp = xml.getElementsByTagName( "AccViewTextClr")[0];
        if( tmp && tmp.textContent !== "") {
            style.view.clrText = fixColor( tmp.textContent);
        }
        ar = getStyles( xml, "AccViewBgClr1", "AccViewBgClr2");
        style.view.clrBg = ( ar.length > 0) ? ar[0] : "";
        style.view.gradBg = ( ar.length === 2) ? ar[1] : "";
        
        tmp = xml.getElementsByTagName( "AccListRowClrs")[0];
        if( tmp && tmp.textContent !== "") {
            ar = tmp.textContent.split(",");
            style.rows.clrEvenBg = fixColor( ar[0]);
            style.rows.clrOddBg = ( ar.length === 2) ? fixColor( ar[1]) : fixColor( ar[0]);
        }
        tmp = xml.getElementsByTagName( "AccListRowTextClrs")[0];
        if( tmp && tmp.textContent !== "") {
            ar = tmp.textContent.split(",");
            style.rows.clrEvenText = fixColor( ar[0]);
            style.rows.clrOddText = ( ar.length === 2) ? fixColor( ar[1]) : style.rows.clrEvenText;
        }
//------------------------------------------------------------------------------------//
              
        tmp = xml.getElementsByTagName( "FloorPlanButtonTextClr")[0];
        if( tmp && tmp.textContent !== "") {
            style.floorplan.clrText = fixColor( tmp.textContent);
        }
        ar = getStyles( xml, "FloorPlanButtonBgClr1", "FloorPlanButtonBgClr2");
        style.floorplan.clrBg = ( ar.length > 0) ? ar[0] : "";
        style.floorplan.gradBg = ( ar.length === 2) ? ar[1] : "";
        
        tmp = xml.getElementsByTagName( "ToolBarBgColor")[0];
        if( tmp && tmp.textContent !== "") {
            style.fpToolbar.clrBg = fixColor( tmp.textContent);
        }
        tmp = xml.getElementsByTagName( "ToolBarTextColor")[0];
        if( tmp && tmp.textContent !== "") {
            style.fpToolbar.clrText = fixColor( tmp.textContent);
        }
        tmp = xml.getElementsByTagName( "ToolBarAlpha")[0];
        if( tmp && tmp.textContent !== "") {
            style.fpToolbar.alpha =  tmp.textContent;
        }
        
        
        
        tmp = xml.getElementsByTagName( "ExhibitorListDefaultToExhibitorsFromAllViews")[0];
        if( tmp && tmp.textContent !== "") {
            config.initialAllExhibitors = isTrue( tmp.textContent);
        }
        tmp = xml.getElementsByTagName( "HideFloorPlanDate")[0];
        if( tmp && tmp.textContent !== "") {
            config.bHideFloorPlanDate = isTrue( tmp.textContent);
        }
        tmp = xml.getElementsByTagName( "ShowLegend")[0];
        if( tmp && tmp.textContent !== "") {
            config.bLegend = isTrue( tmp.textContent);
        }
        tmp = xml.getElementsByTagName( "LegendOpen")[0];
        if( tmp && tmp.textContent !== "") {
            config.legendOpen = isTrue( tmp.textContent);
        }
        tmp = xml.getElementsByTagName( "LegendNoRent")[0];
        if( tmp && tmp.textContent !== "") {
            config.legendRent = !isTrue( tmp.textContent);
        }
        tmp = xml.getElementsByTagName( "LegendNoHold")[0];
        if( tmp && tmp.textContent !== "") {
            config.legendHold = !isTrue( tmp.textContent);
        }
        tmp = xml.getElementsByTagName( "LegendNoAvailable")[0];
        if( tmp && tmp.textContent !== "") {
            config.legendAvailable = !isTrue( tmp.textContent);
        }
        tmp = xml.getElementsByTagName( "LegendFontSize")[0];
        if( tmp && tmp.textContent !== "") {
            config.legendFontSize = tmp.textContent;
        }
        tmp = xml.getElementsByTagName( "LegendBackgroundColor")[0];
        if( tmp && tmp.textContent !== "") {
            config.clrLegendBackground = tmp.textContent;
        }
        tmp = xml.getElementsByTagName( "LegendBackgroundAlpha")[0];
        if( tmp && tmp.textContent !== "") {
            config.LegendBackgroundAlpha = parseFloat( tmp.textContent);		
        }
        tmp = xml.getElementsByTagName( "LegendTextColor")[0];
        if( tmp && tmp.textContent !== "") {
            config.LegendTextColor = tmp.textContent;
        }
		
        tmp = xml.getElementsByTagName( "ShowUpdateMessage")[0];
        if( tmp && tmp.textContent !== "") {
            if( !isTrue( tmp.textContent)) {
            config.updateCheckInterval = 0;
            }
        }
        tmp = xml.getElementsByTagName( "BoothGradient")[0];
        if( tmp && tmp.textContent !== "") {
            config.bBoothGradient = isTrue( tmp.textContent);
        }
        tmp = xml.getElementsByTagName( "BoothGradientBaseColor")[0];
        if( tmp && tmp.textContent !== "") {
            config.clrBoothBase = fixColor( tmp.textContent);
        }
            // UseExpocadBoothColorForAvailableBoothBorder
        tmp = xml.getElementsByTagName( "AvailableBoothBorderColor")[0];
        if( tmp && tmp.textContent !== "") {
            config.borderAvailableWithExpocadColor = isTrue( tmp.textContent);
        }
        tmp = xml.getElementsByTagName( "RentedBoothBorderColor")[0];
        if( tmp && tmp.textContent !== "") {
            config.borderRentedWithExpocadColor = isTrue( tmp.textContent);
        }
        tmp = xml.getElementsByTagName( "HoldBoothBorderColor")[0];
        if( tmp && tmp.textContent !== "") {
            config.borderOnHoldWithExpocadColor = isTrue( tmp.textContent);
        }
        tmp = xml.getElementsByTagName( "ShadeAvailableBoothColors")[0];
        if( tmp && tmp.textContent !== "") {
            config.fillAvailableWithExpocadColor = isTrue( tmp.textContent);
        }
        tmp = xml.getElementsByTagName( "ShadeRentedBoothColors")[0];
        if( tmp && tmp.textContent !== "") {
            config.fillRentedWithExpocadColor = isTrue( tmp.textContent);
        }
        tmp = xml.getElementsByTagName( "ShadeHoldBoothColors")[0];
        if( tmp && tmp.textContent !== "") {
            config.fillOnHoldWithExpocadColor = isTrue( tmp.textContent);
        }
		
        tmp = xml.getElementsByTagName( "BoothBorderWidth")[0];
        if( tmp && tmp.textContent !== "") {
            config.boothBorderLineWidth = parseInt( tmp.textContent, 10);
        }
        tmp = xml.getElementsByTagName( "AdditionalGraphicsLineWidth")[0];
        if( tmp && tmp.textContent !== "") {
            config.additionalGraphicsLineWidth = parseInt( tmp.textContent, 10);
        }
        tmp = xml.getElementsByTagName( "ShowServerTime")[0];
        if( tmp && tmp.textContent !== "") {
            config.bServerTime = isTrue( tmp.textContent);
        }
        tmp = xml.getElementsByTagName( "ServerTimeLabel")[0];
        if( tmp && tmp.textContent !== "") {
            config.serverTimeZoneLabel = tmp.textContent;
        }
        tmp = xml.getElementsByTagName( "ServerTimeOffset")[0];
        if( tmp && tmp.textContent !== "") {
            // Convert string notation - hh:mm:ss to number milliseconds
            ar = tmp.textContent.split(":");
            
            if( ar.length > 0) {
                config.serverTimeOffset = parseInt( ar[0], 10) *3600000;
                if( config.serverTimeOffset < 0) {
                    sign = -1;
                }
            }
            if( ar.length > 1) {
                config.serverTimeOffset += parseInt( ar[1], 10) *60000 * sign;
            }
            if( ar.length > 2) {
                config.serverTimeOffset += parseInt( ar[2], 10) *1000 * sign;
            }
        }
        tmp = xml.getElementsByTagName( "ServerTimeTextColor")[0];
        if( tmp && tmp.textContent !== "") {
            config.serverTimeColor = fixColor( tmp.textContent);
        }
        tmp = xml.getElementsByTagName( "ShowPrintButton")[0];
        if( tmp && tmp.textContent !== "") {
            config.bFloorPlanPrint = isTrue( tmp.textContent);
        }
        tmp = xml.getElementsByTagName( "WindowListPrint")[0];
        if( tmp && tmp.textContent !== "") {
            config.bListPrint = isTrue( tmp.textContent);
        }
        tmp = xml.getElementsByTagName( "WindowPopUpPrint")[0];
        if( tmp && tmp.textContent !== "") {
            config.bPopUpPrint = isTrue( tmp.textContent);
        }
        tmp = xml.getElementsByTagName("HideWindowPopupShare")[0];
        if( tmp && tmp.textContent !== "") {
            config.bPopUpShare = !isTrue( tmp.textContent);
        }
        tmp = xml.getElementsByTagName( "ShowIAmHereButton")[0];
        if( tmp && tmp.textContent !== "") {
            config.bIAmHere = isTrue( tmp.textContent);
        }        
        tmp = xml.getElementsByTagName( "ShowBuildingButton")[0];
        if( tmp && tmp.textContent !== "") {
            config.bBuilding = isTrue( tmp.textContent);
        }     
        tmp = xml.getElementsByTagName( "HideMiniMap")[0];
        if( tmp && tmp.textContent !== "") {
            config.bMiniMap = !(isTrue( tmp.textContent));
        }
        tmp = xml.getElementsByTagName( "MiniMapDefaultOpen")[0];
        if( tmp && tmp.textContent !== "") {
            config.bMiniMapOpen = isTrue( tmp.textContent);
        }
        tmp = xml.getElementsByTagName( "ShowUnitsButton")[0];
        if( tmp && tmp.textContent !== "") {
            config.bUnitsButton = isTrue( tmp.textContent);
        }
            
        tmp = xml.getElementsByTagName( "MapAddressLink")[0];
        if( tmp && tmp.textContent !== "") {
            config.bMapAddress = isTrue( tmp.textContent);
        }
        tmp = xml.getElementsByTagName( "Pass")[0];
        if( tmp && tmp.textContent !== "") {
            config.password = tmp.textContent;
        }
        tmp = xml.getElementsByTagName( "GAAccount")[0];
        if( tmp && tmp.textContent !== "") {
            config.gaAccount = tmp.textContent;
        }
        //  Accordion lists
        tmp = xml.getElementsByTagName( "HideExhibitorListWindow")[0];
        if( tmp && tmp.textContent !== "") {
            config.showLists = !isTrue( tmp.textContent);
        }
		if( config.showLists) {
			tmp = xml.getElementsByTagName( "ListWindowDefaultOpen")[0];
			if( tmp && tmp.textContent !== "") {
                config.defaultListWindowOpen = isTrue( tmp.textContent);
				if( isTrue( tmp.textContent === false)) {
                    util.addClass( elemById( "nav1"), "nav-closed");
                    elemById( "btnListHide").style.left = "0";
				}
			}
		}
		
        tmp = xml.getElementsByTagName( "DefaultList")[0];
        if( tmp && tmp.textContent !== "") {
            config.AccordionDefaultList = tmp.textContent;
        }
        
        tmp = xml.getElementsByTagName( "HideToolBar")[0];
        if( tmp && tmp.textContent !== "") {
            config.bToolbar = !isTrue( tmp.textContent);
        }
        // 3D
        tmp = xml.getElementsByTagName( "No3D")[0];
        if( tmp && tmp.textContent !== "") {
            config.is3d = config.is3d && !isTrue( tmp.textContent);
        }

        tmp = xml.getElementsByTagName( "OpenIn2D")[0];
        if( tmp && tmp.textContent !== "") {
            config.openIn3D = !isTrue( tmp.textContent);
        }
//        Generic prefix for both regular text and sales text was too hard for Andy to change
//          **Language was too hard for Jim to spell
//        tmp = xml.getElementsByTagName( "Languages")[0];
//        if( tmp && tmp.innerHTML !== "") {
//			xmlNodes = tmp.getElementsByTagName( "Language");
//			if( xmlNodes.length > 0) {
//				config.defaultLangauge = tmp.getAttribute( "default");
//				for( i = 0; i < xmlNodes.length; i++) {
//					config.langauges.push(  { name: xmlNodes[i].getAttribute( "displayName"),
//											prefix: xmlNodes[i].getAttribute( "filePrefix")
//											});
//				}
//			}
//        }
		
        tmp = xml.getElementsByTagName( "Languages")[0];
        if( tmp && tmp.innerHTML !== "") {
			xmlNodes = tmp.getElementsByTagName( "Language");
			if( xmlNodes.length > 0) {
				config.defaultlanguage = tmp.getAttribute( "default");
				
				for( i = 0; i < xmlNodes.length; i++) {
					config.languages.push(  { name: xmlNodes[i].getAttribute( "displayName"),
											file: xmlNodes[i].getAttribute( "fileName")
											});
				}
			}
        }
		
/*         tmp = xml.getElementsByTagName( "ELIMessages")[0];
        if( tmp && tmp.innerHTML !== "") {
			xmlNodes = tmp.getElementsByTagName( "Message");
			if( xmlNodes.length > 0) {
				config.is3d = false;
				config.elvis = true;
				for( i = 0; i < xmlNodes.length; i++) {
					config.elvisMessages.push(  { numGroup: xmlNodes[i].getAttribute( "numIndex"),
											msg: xmlNodes[i].textContent
											});
				}
			}
        }
        tmp = xml.getElementsByTagName( "ELINumbers")[0];
        if( tmp && tmp.innerHTML !== "") {
			xmlNodes = tmp.getElementsByTagName( "Numbers");
			if( xmlNodes.length > 0) {
				for( i = 0; i < xmlNodes.length; i++) {
					config.elvisNumbers.push( xmlNodes[i].textContent);
				}
			}
        } */

        tmp = xml.getElementsByTagName( "ELI")[0];
        if( tmp && tmp.textContent !== "") {
            config.elvis = isTrue( tmp.textContent);
			if( config.elvis) {
                config.is3d = false;
			}
        }
		
        tmp = xml.getElementsByTagName( "Premium")[0];
        if( tmp && tmp.innerHTML !== "") {
			xmlNodes = tmp.getElementsByTagName( "Company");
			if( xmlNodes.length > 0) {
				for( i = 0; i < xmlNodes.length; i++) {
					data.premiumCompanies.push( { name: xmlNodes[i].getAttribute( "name"),
											priority: xmlNodes[i].getAttribute( "level") });
				}
			}
			xmlNodes = tmp.getElementsByTagName( "Level");
			if( xmlNodes.length > 0) {
				for( i = 0; i < xmlNodes.length; i++) {
					data.premiumLevels.push( { level: xmlNodes[i].getAttribute( "level"),
											clrBackground: xmlNodes[i].getAttribute( "background"),
											clrText: xmlNodes[i].getAttribute( "text"),
											iconCode: xmlNodes[i].getAttribute( "icon")});
				}
			}
			
        }
		
		tmp = xml.getElementsByTagName( "FlyoutBackgroundColor")[0];
        if( tmp && tmp.textContent !== "") {
            config.clrFlyoutBackground = fixColor( tmp.textContent);
        }
		tmp = xml.getElementsByTagName( "FlyoutTextColor")[0];
        if( tmp && tmp.textContent !== "") {
            config.clrFlyoutText = fixColor( tmp.textContent);
        }
		tmp = xml.getElementsByTagName( "FlyoutFontSize")[0];
        if( tmp && tmp.textContent !== "") {
            config.flyoutFontSize = tmp.textContent + "px";
        }

        tmp = xml.getElementsByTagName( "HideAvailableBoothList")[0];
        if( tmp && tmp.textContent !== "") {
            config.bHideAvailableList = isTrue(tmp.textContent);
        }

        tmp = xml.getElementsByTagName( "HideDimensionButton")[0];
        if( tmp && tmp.textContent !== "") {
            config.bDimensions = !isTrue(tmp.textContent);
        }
        
        tmp = xml.getElementsByTagName( "StartDimensionsOn")[0];
        if( tmp && tmp.textContent !== "") {
            if(config.bDimensions == true){
                config.showDimensions = isTrue(tmp.textContent);
            }            
        }
		
        xml = null;
    }
    
    return {
		config: saveConfig,
		multiConfig: multiConfig,
		options: options
	};
}());
    

